import { useRef, useEffect, useState, useCallback } from 'react';
import styles from './animacioEclipsi.module.scss';
import Icona from 'components/3catinfo/ui/Icona';

const DURACIO_PAUSA = 1000; // pausa de la lluna quan arriva al centre
const DURACIO_TOTAL = 20000; // duració total animació
const TAMANY_SOL = 287; // tamany del sol en px

const AnimacioEclipsi = ({ percentatge = 100 }) => {
    const timeoutEntrada = useRef(null);
    const timeoutSortida = useRef(null);
    const llunaRef = useRef(null); // referencia del DOM per saber la posició del CSS de la lluna
    const solRef = useRef(null); // referencia del DOM per saber el tamany del sol
    const intervalAnellRef = useRef(null);
    const [llunaOffset, setLlunaOffset] = useState({
        x: Math.round(TAMANY_SOL / Math.sqrt(2)),
        y: Math.round(TAMANY_SOL / Math.sqrt(2))
    }); // posició de la lluna
    const [duracioTransicio, setDuracioTransicio] = useState(0); // duració de la transició
    const [animacio, setAnimacio] = useState(false); // activa i desactiva l'animació
    const [isAnimacioAcabat, setIsAnimacioAcabat] = useState(false); // controlar quan acaba l'animació per mostrar boto de reset
    const [mostrarAnell, setMostrarAnell] = useState(false);

    const runAnimation = useCallback(() => {
        clearTimeout(timeoutEntrada.current);
        clearTimeout(timeoutSortida.current);
        setMostrarAnell(false);

        const tamanySol = solRef.current?.offsetWidth || TAMANY_SOL;
        const actualOffset = Math.round(tamanySol / Math.sqrt(2));
        const target = Math.round(actualOffset * (1 - percentatge / 100)); // calcula on ha de parar la lluna segons el percentatge

        // calcula les duració proporcional a la distancia
        const distanciaEntrada = actualOffset - target;
        const distanciaSortida = actualOffset + target;
        const distanciaTotal = distanciaEntrada + distanciaSortida;
        const duracionEntrada = Math.round(DURACIO_TOTAL * (distanciaEntrada / distanciaTotal));
        const duracionSortida = DURACIO_TOTAL - duracionEntrada;

        setAnimacio(false); // desactivem l'animació CSS
        setIsAnimacioAcabat(false);
        setDuracioTransicio(0);
        setLlunaOffset({ x: actualOffset, y: actualOffset }); // posició inicial de la lluna

        setTimeout(() => {
            setAnimacio(true);
            setDuracioTransicio(duracionEntrada);
            setLlunaOffset({ x: target, y: target }); // es mou la lluna cap al sol

            timeoutEntrada.current = setTimeout(() => {
                if (percentatge === 100) setMostrarAnell(true);
                // quan arriva al sol deixem 1s de pausa
                setTimeout(() => {
                    setDuracioTransicio(duracionSortida);
                    setLlunaOffset({ x: -(actualOffset + 10), y: -actualOffset }); // seguim amb la segona part de l'animació

                    intervalAnellRef.current = setInterval(() => {
                        if (!llunaRef.current) return;
                        const matrix = new DOMMatrix(getComputedStyle(llunaRef.current).transform);
                        const absX = Math.abs(matrix.m41);
                        const pct = absX >= actualOffset ? 0 : Math.round((1 - absX / actualOffset) * 100);

                        if (pct === 100 && percentatge === 100) {
                            setMostrarAnell(true);
                        } else {
                            setMostrarAnell(false);
                            clearInterval(intervalAnellRef.current);
                        }
                    }, 100);

                    timeoutSortida.current = setTimeout(() => {
                        // acaba l'animació de la lluna
                        setIsAnimacioAcabat(true);
                        setMostrarAnell(false);
                    }, duracionSortida);
                }, DURACIO_PAUSA);
            }, duracionEntrada); // timeout de l'entrada i la pausa
        }, 50);
    }, [percentatge]);

    useEffect(() => {
        runAnimation();

        return () => {
            clearTimeout(timeoutEntrada.current);
            clearTimeout(timeoutSortida.current);
            clearInterval(intervalAnellRef.current);
        };
    }, [runAnimation]);

    return (
        <div className={styles.containerAnimacio}>
            {mostrarAnell && (
                <img
                    src={'https://statics.3cat.cat/recursos/3catinfo/img/eclipsi/coronasolar-eclipsi.png'}
                    className={styles.anellSol}
                    alt=''
                />
            )}
            <div className={styles.eclipsiWrapper}>
                <div className={styles.solLlunaWrapper}>
                    <div ref={solRef} className={styles.sol}>
                        <div
                            ref={llunaRef}
                            className={styles.lluna}
                            style={{
                                transition: animacio ? `transform ${duracioTransicio / 1000}s linear` : 'none',
                                transform: `translate(${llunaOffset.x}px, ${llunaOffset.y}px)`
                            }}
                        />
                        {isAnimacioAcabat && (
                            <button className={styles.botoReset} onClick={runAnimation}>
                                <Icona icona={'tornaaveure'} inline={true} isBlanc={true} mida={48} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnimacioEclipsi;
